import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "./common-component/Loader";
import { useDispatch } from "react-redux";
import {
  organizations,
  userInfo,
  userRoleRight,
  userToken,
} from "../services/ReduxTookit/UserInfoSlice";
import { getLoginDataUsingToken } from "../services/ReduxTookit/Slice/LoginRedux";
import { GetByPrimarykey } from "../services/ReduxTookit/Slice/UserRedux";

const HandleNavigate = () => {
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  const navigate = useNavigate();
  let dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const df_token = params.get("df_token");

  if (df_token) {
    dispatch(userToken(df_token));
    let body = {      
      loginfrom: DevRoute ? "Developer" : "DataFactory",
    };
    dispatch(getLoginDataUsingToken(body))?.then((response) => {
      
      if (response?.payload?.isValidate) {
        dispatch(userInfo(response?.payload?.data?.data?.dataList1[0]));
        dispatch(userRoleRight(response?.payload?.data?.data?.dataList2));
        dispatch(organizations(response?.payload?.data?.data?.dataList3));
        dispatch(GetByPrimarykey({}));
        navigate(`${process.env.REACT_APP_WORKFLOW}`);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
};

export default HandleNavigate;
